import * as React from 'react';
import AddNewOrderView from '../layouts/AddNewOrderView';

export interface NewOrderPageProps {
    onComponentDidMount: (url: string ) => void;
    onSubmit: () => void;
    btnElement: string;
    btnType: string;
}

class NewOrderPage extends React.Component<NewOrderPageProps> {
    render() {
        return (
            <AddNewOrderView />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
    }
}

export default NewOrderPage;



// WEBPACK FOOTER //
// ./src/components/order/NewOrderPage.tsx